import { Box, Card } from '@mui/material'
import React from 'react'
// import "./style.css";
import { ThemeProvider } from './ThemeContext2';
import POSHeader from 'components/POSHeader';

const MainContainer = ({children, height, padding, bgcolor}) => {
  return (
    // <Box className='main-body-container'>
    //   <Card className='main-body-card' sx={{ minHeight: height ? height : "calc(100vh - 122px)"}}>
    //     {children}
    //   </Card>
    // </Box>
    <ThemeProvider>
        <Box sx={{ bgcolor: bgcolor ? bgcolor : "#fff", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
          <POSHeader/>
          <Box className="pos-container" sx={{ padding: padding ? padding : '0px 24px', flexGrow: 1 }}>
            {children}
          </Box>
        </Box>
    </ThemeProvider>
  )
}

export default MainContainer
